// src/sanitize.ts
// Ads are written in a rich-text editor and stored as HTML. Anyone could
// save HTML directly to the database, so before showing it we strip
// everything except simple formatting: no scripts, styles, frames,
// images, event handlers, or javascript: links.
import DOMPurify from "dompurify";

const ALLOWED_TAGS = [
  "p", "br", "strong", "b", "em", "i", "u", "s", "strike",
  "h1", "h2", "h3", "ul", "ol", "li", "blockquote", "a", "span",
];

let hooked = false;

export function sanitizeHtml(html: string | undefined): string {
  if (!hooked) {
    // Links open in a new tab and can't reach back into this page.
    DOMPurify.addHook("afterSanitizeAttributes", (node) => {
      if (node.tagName === "A") {
        node.setAttribute("target", "_blank");
        node.setAttribute("rel", "noopener noreferrer nofollow");
      }
    });
    hooked = true;
  }
  return DOMPurify.sanitize(html || "", {
    ALLOWED_TAGS,
    ALLOWED_ATTR: ["href"],
    ALLOWED_URI_REGEXP: /^(?:https?:|mailto:)/i,
  });
}
